<template>
  <section ref="pc_common" :class="`${classs} detect_deviece_${deviceType} state_${deviceType}`">
    <HeadBar :title="title" :deviceType="deviceType" />
    <slot />
    <FootBar :deviceType="deviceType" />
  </section>
</template>

<script>
import HeadBar from '@/pages/components/head.vue';
import FootBar from '@/pages/components/footer.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    HeadBar,
    FootBar
  },
  props: {
    classs: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'EvolonikAI',
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'host',
    ])
  },

};
</script>